/**
 * Thin boot loader — loads core + app only when section is opened or visible.
 */
(function () {
  'use strict';

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (!src) {
        reject(new Error('Missing script src'));
        return;
      }
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
          return;
        }
        var settled = false;
        function done() {
          if (settled) return;
          settled = true;
          existing.dataset.loaded = 'true';
          resolve();
        }
        existing.addEventListener('load', done);
        existing.addEventListener('error', reject);
        // Parser-inserted scripts that already ran never fire `load` again.
        if (existing.readyState === 'complete' || existing.readyState === 'loaded') {
          done();
        }
        return;
      }
      var s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.onload = function () {
        s.dataset.loaded = 'true';
        resolve();
      };
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function initSection(root) {
    if (!root || root.dataset.gwBooted === 'true') return;
    root.dataset.gwBooted = 'true';

    var openBtn = root.querySelector('[data-action="open-visualizer"]');
    var layout = root.querySelector('[data-gw-viz-root]');
    var loading = false;

    function boot() {
      if (loading || root.dataset.gwReady === 'true') return Promise.resolve();
      loading = true;
      var reconSrc = root.getAttribute('data-reconstruct-src');
      var pickerSrc = root.getAttribute('data-picker-src');
      var coreSrc = root.getAttribute('data-core-src');
      var appSrc = root.getAttribute('data-app-src');
      var haveRecon =
        typeof window.GWFrameReconstruct === 'object' &&
        window.GWFrameReconstruct &&
        typeof window.GWFrameReconstruct.drawReconstructedFrame === 'function';
      var havePicker =
        typeof window.GWFramePicker === 'object' &&
        window.GWFramePicker &&
        typeof window.GWFramePicker.mount === 'function';
      return (reconSrc && !haveRecon ? loadScript(reconSrc) : Promise.resolve())
        .catch(function (err) {
          console.warn('[gw-wall-visualizer] reconstruct failed', err);
        })
        .then(function () {
          return pickerSrc && !havePicker ? loadScript(pickerSrc) : Promise.resolve();
        })
        .catch(function (err) {
          console.warn('[gw-wall-visualizer] frame picker failed', err);
        })
        .then(function () {
          return loadScript(coreSrc);
        })
        .then(function () {
          return loadScript(appSrc);
        })
        .then(function () {
          if (typeof window.GWVisualizerApp === 'function') {
            window.GWVisualizerApp(root);
          }
          root.dataset.gwReady = 'true';
          root.classList.add('is-ready');
          if (layout) layout.hidden = false;
          if (openBtn) openBtn.hidden = true;
          if (typeof window.gwfineTrackVisualizer === 'function') {
            window.gwfineTrackVisualizer('wall_visualizer_opened');
          }
        })
        .catch(function (err) {
          console.error('[gw-wall-visualizer] failed to load', err);
          loading = false;
          root.dataset.gwBooted = 'false';
        });
    }

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        boot();
      });
    }

    // Auto-boot when section scrolls into view on dedicated page (not PDP with closed state)
    // Staff Mockup Studio always boots immediately.
    var auto =
      root.getAttribute('data-mode') === 'page' || root.getAttribute('data-staff-mode') === 'true';
    if (root.getAttribute('data-staff-mode') === 'true' || auto) {
      boot();
    } else if (auto && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              boot();
              io.disconnect();
            }
          });
        },
        { rootMargin: '100px', threshold: 0.15 }
      );
      io.observe(root);
    }
  }

  function scan() {
    document.querySelectorAll('.gw-visualizer').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var root = e.target.querySelector('.gw-visualizer');
    if (root) initSection(root);
  });
})();
